import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
var GroupPlaybackControls = /*#__PURE__*/function () {
  function GroupPlaybackControls(animations) {
    _classCallCheck(this, GroupPlaybackControls);
    this.animations = animations.filter(Boolean);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  _createClass(GroupPlaybackControls, [{
    key: "currentTime",
    get: function get() {
      return this.animations[0].currentTime;
    }
    /**
     * currentTime assignment could reasonably run every frame, so
     * we iterate using a normal loop to avoid function creation.
     */,
    set: function set(time) {
      for (var i = 0; i < this.animations.length; i++) {
        this.animations[i].currentTime = time;
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.animations.forEach(function (controls) {
        return controls.stop();
      });
    }
  }]);
  return GroupPlaybackControls;
}();
export { GroupPlaybackControls };